export default "__VITE_ASSET__BeNAjMC3__"